export default __webpack_public_path__ + "static/media/andor5.80d49d75.jpeg";